import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ManikEntityFE } from '../manik-library/ManikEntityFE';
import { ManikEntityService } from '../manik-library/ManikEntityService';

@Component({
  selector: 'app-buyer-pass-code',
  templateUrl: './buyer-pass-code.component.html',
  styleUrls: ['./buyer-pass-code.component.scss']
})
export class BuyerPassCodeComponent extends ManikEntityFE implements OnInit {
  PassCodeList: { PassCode: string }[] = [];//buyer
  PassCodeList2: { OTP: string }[] = [];
  constructor(public _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document: any) {
    super(document);
  }

  ngOnInit() {
    this.refreshDataGrid();
  }

  populateControls(): void {
  }
  refreshDataGrid(param: any = null): void {
    sessionStorage.setItem("PortalIdentifier", "DEVCITY");
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2("UNVERIFIED.BUYER.PASSCODE", "BUSINESSWORKS.BUYER", "BIZ", "DEVCITY"))
      .subscribe(data => {
        this.PassCodeList = data.ManikJSon[0].JSon0;
      });
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null, this.prepareAPIRequestHeaders2("PROCESSOR", "LAST.OTP"))
      .subscribe(data => {
        this.PassCodeList2 = data.ManikJSon[0].JSon0;
        console.log(this.PassCodeList2);
      });
  }





}
